import styles from './card.module.scss';
import Heading from '../Heading/Heading';
import TableWithColumns from 'slices/TableWithColumns';
import { Button } from '@get-mosh/msh-shared';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { trackClick } from 'src/analytics/Events';
import EventNames from 'src/analytics/EventNames';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export type CardProductProps = {
    name: string;
    value?: string;
    prefix?: string;
    frequency?: string;
    main_image?: any;
    icon?: any;
    className?: string;
    cta_link?: string;
    cta_label?: string;
    badge?: string;
    usp?: string;
    active_ingredients?: number;
    slices: any[]; // TODO: type for this
    location?: string;
};

const CardProduct = (props: CardProductProps) => {
    return (
        <div className={classNames(styles['product'], props.className)}>
            <div className={styles['top']}>
                <div
                    className={classNames(
                        styles['badge'],
                        !props.badge && 'invisible',
                    )}
                >
                    <span>{props.badge}</span>
                </div>
                <div className={styles['icon']}>
                    <img
                        src={props.icon?.url}
                        alt={props.icon?.alt}
                        width={30}
                        height={30}
                    />
                </div>
            </div>
            <div className={styles['name']}>
                <Heading level={'h3'} tag={'h'} centered={true}>
                    {props.name}
                </Heading>
            </div>
            <div className={styles['section']}>
                <div className={styles['image']}>
                    {props.main_image?.square.url ? (
                        <img
                            src={props.main_image?.square.url}
                            width={props.main_image?.square.dimensions.width}
                            height={props.main_image?.square.dimensions.height}
                            alt={props.main_image?.alt}
                        />
                    ) : (
                        <img
                            src={props.main_image?.url}
                            width={props.main_image?.dimensions.width}
                            height={props.main_image?.dimensions.height}
                            alt={props.main_image?.alt}
                        />
                    )}
                    {props.active_ingredients && (
                        <div className={styles['active-ingredients']}>
                            {`${props.active_ingredients} active ingredient`}
                            {props.active_ingredients > 1 && 's'}
                        </div>
                    )}
                </div>
                <div className={styles['content']}>
                    {props.usp && (
                        <div className={styles['usp']}>
                            <span>
                                <FontAwesomeIcon icon={faCheck} />
                                {props.usp}
                            </span>
                        </div>
                    )}
                    {props.slices && (
                        <div className={styles['slices']}>
                            {props.slices.map((slice, i) => {
                                if (slice.slice_type === 'table_with_columns') {
                                    return (
                                        <div key={i}>
                                            <TableWithColumns
                                                index={i}
                                                slice={slice}
                                                context={{}}
                                                slices={[]}
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                    )}
                    <div className={styles['bottom']}>
                        <span className={styles['price']}>
                            {props.prefix}
                            {'$' + props.value}
                            {props.frequency}
                        </span>
                        <Button
                            text={props.cta_label}
                            href={props.cta_link}
                            as="a"
                            onClick={() => {
                                trackClick(EventNames.BUTTON_CLICKED, {
                                    title: props.name,
                                    label: props.cta_label,
                                    link: props.cta_link,
                                    location: props.location,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardProduct;
